import { Component } from '@angular/core';

import {VoiceService} from '../../services/voice/voice.service';
import {WordPlayBtnComponent} from './word-play-btn.component';

@Component({
  selector: 'app-word-homonym-play-btn',
  styleUrls: ['./word-homonym-play-btn.component.scss'],
  template: `
    <a *ngIf="word.wordVoice"
       class="item-sound-btn {{ on ? 'on' : '' }}"
       (click)="playSound($event)"></a>
  `,
})
export class WordHomonymPlayBtnComponent extends WordPlayBtnComponent{

  constructor(
    protected voice: VoiceService,
  ) {
    super(voice);
  }

}
